/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { ICollection$1_$type, IEnumerable$1_$type, IEnumerable_$type, Type } from "./type";
import { KeyValuePair$2 } from "./KeyValuePair$2";
/**
 * @hidden
 */
export var IDictionary$2_$type = /*@__PURE__*/ new Type(null, 'IDictionary$2', null, [/*@__PURE__*/ ICollection$1_$type.specialize(/*@__PURE__*/ KeyValuePair$2.$.specialize(0, 1)), /*@__PURE__*/ IEnumerable$1_$type.specialize(/*@__PURE__*/ KeyValuePair$2.$.specialize(0, 1)), IEnumerable_$type]);
//# sourceMappingURL=IDictionary$2.js.map
